import React from 'react'
import { FieldsetItem } from './FieldsetItem/FieldsetItem'
import { FieldsetRow } from './FieldsetRow/FieldsetRow'
import * as S from './styled'
import type { FieldsetProps } from './types'

export const Fieldset = ({ children }: FieldsetProps) => {
  return <S.Container>{children}</S.Container>
}

Fieldset.Item = FieldsetItem
Fieldset.Row = FieldsetRow
